import { useEffect, useRef, useState } from 'react';


import { useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import StudentManagementService from '../services/StudentManagementService';

import './StudentSyncIssueMonitor.css';
import './StudentManagementElegant.css';
import './StudentManagementPolish.css';
import './StudentManagementFilterFix.css';
import './StudentManagementAttendanceUx.css';
import './AttendeeManagementElegant.css';
import './AttendeeManagementPolish.css';
import './AttendeeManagementFilterFix.css';
import './AttendeeManagementAttendanceUx.css';

const showIntegrationIssueNotices = false;

const titleForDirection = (direction) => {
  if (direction === 'OUTBOUND') return 'Falha ao enviar aluno para outro sistema';
  if (direction === 'INBOUND') return 'Falha ao receber aluno de outro sistema';
  return 'Integração de alunos requer atenção';
};

const digitsOnly = (value) => String(value || '').replace(/\D/g, '');
const maskCpfValue = (value) => digitsOnly(value)
  .slice(0, 11)
  .replace(/(\d{3})(\d)/, '$1.$2')
  .replace(/(\d{3})(\d)/, '$1.$2')
  .replace(/(\d{3})(\d{1,2})$/, '$1-$2');

const setNativeInputValue = (input, value) => {
  if (!input) return;
  const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')?.set;
  if (setter) setter.call(input, value);
  else input.value = value;
};

const labelText = (label) => String(label?.querySelector(':scope > span')?.textContent || '')
  .replace(/\s*\*$/, '')
  .trim();

const addClassForLabel = (labels, text, className) => {
  labels.filter((label) => labelText(label) === text).forEach((label) => label.classList.add(className));
};

const bindCpfMask = (label) => {
  const input = label?.querySelector('input');
  if (!input) return;
  input.inputMode = 'numeric';
  input.maxLength = 14;
  input.placeholder = input.placeholder || '000.000.000-00';
  if (!input.dataset.ibpmCpfFilterMaskBound) {
    const keepMasked = () => {
      if (!document.body.contains(input)) return;
      const masked = maskCpfValue(input.value);
      if (input.value !== masked) setNativeInputValue(input, masked);
    };
    const handleInputCapture = (event) => {
      const target = event.currentTarget;
      const raw = digitsOnly(target.value).slice(0, 11);
      setNativeInputValue(target, raw);
      window.requestAnimationFrame(() => {
        if (!document.body.contains(target)) return;
        setNativeInputValue(target, maskCpfValue(raw));
        try { target.setSelectionRange(target.value.length, target.value.length); } catch {}
      });
    };
    input.addEventListener('input', handleInputCapture, true);
    input.addEventListener('focus', keepMasked);
    input.addEventListener('blur', keepMasked);
    input.dataset.ibpmCpfFilterMaskBound = 'true';
  }
  if (document.activeElement !== input) {
    const masked = maskCpfValue(input.value);
    if (input.value !== masked) setNativeInputValue(input, masked);
  }
};

const enhanceStudentManagementUx = (root = document.querySelector('.students')) => {
  if (!root) return;
  const consultationForm = root.querySelector('.students__report--enhanced > .students__form');
  if (consultationForm) {
    const labels = Array.from(consultationForm.querySelectorAll(':scope > label'));
    addClassForLabel(labels, 'Nome', 'students__filter-name-ux');
    addClassForLabel(labels, 'CPF', 'students__filter-cpf-ux');
    addClassForLabel(labels, 'Whatsapp', 'students__filter-whatsapp-ux');
    addClassForLabel(labels, 'E-mail', 'students__filter-email-ux');
    addClassForLabel(labels, 'Inscrição de', 'students__filter-date-ux');
    addClassForLabel(labels, 'até', 'students__filter-date-ux');
    addClassForLabel(labels, 'Data de nascimento', 'students__filter-date-ux');
    addClassForLabel(labels, 'Saída de', 'students__filter-date-ux');
    addClassForLabel(labels, 'Status', 'students__filter-status-ux');
    addClassForLabel(labels, 'Turma', 'students__filter-class-ux');
    addClassForLabel(labels, 'Motivo de saída', 'students__filter-exit-reason-ux');
    bindCpfMask(labels.find((label) => labelText(label) === 'CPF'));
  }
  root.querySelectorAll('.students__table--consultation button').forEach((button) => {
    if (String(button.textContent || '').trim() === 'Selecionar') button.textContent = 'Abrir';
  });
  root.querySelectorAll('.students__card').forEach((card) => {
    const title = String(card.querySelector(':scope > .students__section-title h2')?.textContent || '').trim();
    if (title.includes('Nova Chamada')) card.classList.add('students__ux-attendance-card');
    if (title.includes('Lista de Frequência')) card.classList.add('students__ux-attendance-list-card');
    if (title.includes('Histórico de Frequência')) card.classList.add('students__ux-history-card');
  });
};

export default function StudentSyncIssueMonitor() {
  const { token } = useAuth();
  const location = useLocation();
  const seenIssuesRef = useRef(new Map());
  const [notice, setNotice] = useState(null);
  
  

  useEffect(() => {
    if (!token || !location.pathname.startsWith('/dashboard')) return undefined;
    let frame = 0;
    let rootObserver = null;
    let discoveryObserver = null;
    let boundRoot = null;
    const apply = () => {
      if (!boundRoot) return;
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => enhanceStudentManagementUx(boundRoot));
    };
    const bindRoot = () => {
      const nextRoot = document.querySelector('.students');
      if (!nextRoot) return false;
      if (nextRoot === boundRoot && rootObserver) return true;
      rootObserver?.disconnect();
      boundRoot = nextRoot;
      apply();
      rootObserver = new MutationObserver(apply);
      rootObserver.observe(boundRoot, { childList: true, subtree: true });
      return true;
    };
    if (!bindRoot()) {
      discoveryObserver = new MutationObserver(() => {
        if (bindRoot()) discoveryObserver?.disconnect();
      });
      discoveryObserver.observe(document.body, { childList: true, subtree: true });
    }
    return () => {
      rootObserver?.disconnect();
      discoveryObserver?.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, [token, location.pathname]);

  

  useEffect(() => {
    if (!token || !location.pathname.startsWith('/dashboard')) return undefined;
    let cancelled = false;
    let running = false;
    const markSurfaced = async (issueKey) => {
      if (!issueKey) return;
      try { await StudentManagementService.markIntegrationSyncIssueSurfaced(issueKey); } catch {}
    };
    const check = async () => {
      if (running || cancelled) return;
      running = true;
      try {
        const issues = await StudentManagementService.listIntegrationSyncIssues({ unsurfaced: true });
        for (const issue of Array.isArray(issues) ? issues : []) {
          if (cancelled) break;
          const issueKey = String(issue?.issueKey || '');
          if (issue?.direction === 'CONFIGURATION') { await markSurfaced(issueKey); continue; }
          const reason = String(issue?.reason || 'Falha de sincronização sem motivo informado.');
          const previousReason = issueKey ? seenIssuesRef.current.get(issueKey) : undefined;
          const shouldDisplay = !issueKey || previousReason !== reason;
          if (issueKey) seenIssuesRef.current.set(issueKey, reason);
          if (shouldDisplay) {
            const details = [];
            if (issue?.sourceKey) details.push(`Sistema: ${issue.sourceKey}`);
            if (issue?.courseId) details.push(`Curso: ${issue.courseId}`);
            setNotice({ issueKey: issueKey || `${Date.now()}`, title: titleForDirection(issue?.direction), message: [reason, details.join(' • ')].filter(Boolean).join('\n') });
          }
          await markSurfaced(issueKey);
        }
      } catch {} finally { running = false; }
    };
    check();
    const timer = window.setInterval(check, 12000);
    return () => { cancelled = true; window.clearInterval(timer); };
  }, [token, location.pathname]);

  

  

  return (
    <>
      
      {showIntegrationIssueNotices && notice ? (
        <aside className="student-sync-notice" role="status" aria-live="polite">
          <div><strong>{notice.title}</strong><p>{notice.message}</p></div>
          <button type="button" onClick={() => setNotice(null)} aria-label="Fechar aviso de sincronização">Fechar</button>
        </aside>
      ) : null}
    </>
  );
}

/* react-owned-management-toolbar-v1 */
